import { render, staticRenderFns } from "./verify-order.vue?vue&type=template&id=3b3a2386"
import script from "./verify-order.vue?vue&type=script&lang=js"
export * from "./verify-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports